import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux';
import estilos from "../../../UsuarioInspectorEnCampo/Asociados/Tabs/TabsInspeccionarComponent.module.css";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { getAllSolicitudesACUI, insertSolicitud, updateSolicitud } from '../../../../redux/DucksUnidadInspeccion/SolicitudesUIF01Duck';
import Swal from 'sweetalert2';
import { generarSolicitudAsignacionServicios, obtenerSolicitudByIdSolicitudFC01 } from '../../../../redux/DucksUnidadInspeccion/DocumentosDuck';
import { host } from '../../../../configuraciones';
import Modal from '@mui/material/Modal';
const style = {
    position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '90%',
    bgcolor: 'background.paper', border: '2px solid #000', boxShadow: 24, p: 4,
};
const styleNormal = {
    "& legend": { display: "none" },
    "& fieldset": { top: 0 },
    background: "white",
};
import moment from 'moment'
import TextField from "@mui/material/TextField";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Typography from '@mui/material/Typography';
import { ErrorMessage, Field, FieldArray, Form, Formik } from 'formik';
import InputLabel from '@mui/material/InputLabel';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import esLocale from "date-fns/locale/es";
import { getInspectores } from '../../../../redux/DucksUnidadInspeccion/InspectoresDuck';
import { obtenerInstalacionesFC_01 } from '../../../../redux/DucksUnidadInspeccion/InstalacionDuck';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../../redux/AppDucks';
function QuickSearchToolbar() {
    return (
        <Box
            sx={{ p: 0.5, pb: 0, mb: 2, textAlign: 'left', height: 30, width: '100%', backgroundColor: 'white', textAlign: 'end' }}>
            <GridToolbarQuickFilter style={{ width: '25%', }} placeholder='Búsqueda...' />
        </Box>
    );
}
function SolicitudFC01UIComponent(props) {
    const dispatch = useDispatch();

    const currentUser = useSelector(store => store.Usuario.data)

    const [rows, setRows] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [pageSize, setPageSize] = React.useState(10);
    const [total, setTotal] = React.useState(0);

    const [inspectores, setInspectores] = React.useState([]);
    console.log('los datos es ', inspectores)
    React.useEffect(() => {
        dispatch(getInspectores()).then((res) => {
            setInspectores(res.payload.data.data);
        });
    }, []);

    let columns = [

        {
            field: "folio", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Folio", flex: .7,
        },
        {
            field: "nombre", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Nombre o razon social", flex: 1,
        },
        {
            field: "socio", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "No. de socio", flex: .5,
        },
        /*{
            field: "eslabones", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Cadena Productiva", flex: 1,
        },*/
        {
            field: "estatus", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Estatus", flex: 1,
        },
        {
            field: "revisor", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Revisor UI", flex: 1,
        },
        {
            field: "accion", headerAlign: "center", headerClassName: estilos.headerSolicitudes,
            headerName: "Acciones", flex: 1,
            renderCell: (params) => {
                const inspector = params.row; // los datos de la fila
                return (
                    <>
                        <Tooltip title="Ver Solicitud">
                            <IconButton onClick={() => verSolicitud(params.row)} size="small" color="secondary" >
                                <AssignmentIcon />
                            </IconButton>
                        </Tooltip>
                        {params.row?.anexo?.solicitudesuifc01?.[0]?.idsolicitudesuifc01 &&
                            <Tooltip title="Ver asignación de servicio">
                                <IconButton onClick={() => verDocumentoAsignacion(params.row)} size="small" color="primary" >
                                    <AssignmentTurnedInIcon />
                                </IconButton>
                            </Tooltip>}

                        <Tooltip title="Asignar">
                            <IconButton onClick={() => handleOpenModalAsignarInspector(params.row)} size="small" color="success" >

                                {params.row?.anexo?.solicitudesuifc01?.[0]?.idsolicitudesuifc01 ? <ManageAccountsIcon /> : <PersonAddIcon />}
                            </IconButton>
                        </Tooltip>
                        {params.row?.anexo?.solicitudesuifc01?.[0]?.statusdelasolicitud >= 2 &&
                            <Tooltip title="Ver Informe">
                                <IconButton onClick={() => handleOpenModalAsignarInspector(params.row)} size="small" color="success" >

                                     <AssignmentIcon />
                                </IconButton>
                            </Tooltip>
                        }
                        {params.row?.anexo?.solicitudesuifc01?.[0]?.statusdelasolicitud >= 4 &&
                            <Tooltip title="Ver Dictámen">
                                <IconButton onClick={() => handleOpenModalAsignarInspector(params.row)} size="small" color="success" >
                                     <DocumentScannerIcon />
                                </IconButton>
                            </Tooltip>
                        }

                        {/*

                            solicitud.solicitudesuifc01.length > 0 ?
                                solicitud.solicitudesuifc01[0]?.statusdelasolicitud === 1 ?
                                    <button onClick={() => handleOpenModalAsignarInspector(2)} className='badge btn-primary'><AccessibilityIcon />Reasignar</button>
                                    :
                                    <div></div>
                                :
                                <button onClick={() => handleOpenModalAsignarInspector(1)} className='badge btn-primary'><AccessibilityIcon />Asignar</button>

                */}
                    </>
                );
            },
        },

    ];
    const verSolicitud = (data) => {
        console.log('los datos de data es ', data)
        Swal.fire({
            title: "Visualizar Documentos",
            text: "Selecciona una opción:",
            icon: "question",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "FC01",
            denyButtonText: "Servicio",
            cancelButtonText: "Cerrar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                const fileFetch = await fetch(host + `FC_01/servirAchivosGenerales/tabla=${'fc_01_documentos'}&nombreId=${'idfc01_solicitudregistro'}&idSolicitud=${data?.id}&idoficio=${6}`)

                if (fileFetch.status != 404) {
                    const blob = await fileFetch.blob();
                    const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                    window.open(url);
                } else {
                    Swal.fire("Archivo no encontrado", "", "error");
                }
            } else if (result.isDenied) {
                const fileFetch = await fetch(host + `FC_01/servirAchivosGenerales/tabla=${'fc_01_documentos'}&nombreId=${'idfc01_solicitudregistro'}&idSolicitud=${data?.id}&idoficio=${4}`)

                if (fileFetch.status != 404) {
                    const blob = await fileFetch.blob();
                    const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                    window.open(url);
                } else {
                    Swal.fire("Archivo no encontrado", "", "error");
                }
            }
        });
    }
    const [openModalAsignarInspector, setOpenModalAsignarInspector] = React.useState(false);

    React.useEffect(() => {
        dispatch(getAllSolicitudesACUI({
            status: 4,
            tipo: 'fc_01_solicitudderegistro',
            skip: page * pageSize,
            take: pageSize,
        })).then((res) => {
            console.log('los datos de res es ', res)
            const data = res?.payload?.data?.data?.solicitudes || [];
            setTotal(res?.payload?.data?.data?.total || 0);
            const formattedRows = data.map(anexo => {
                let estatus = '';
                if (anexo?.solicitudesuifc01.length === 0) estatus = 'Sin Asignar';
                if (anexo?.solicitudesuifc01?.[0]?.statusdelasolicitud === 1) estatus = 'Asignada inspector';
                if (anexo?.solicitudesuifc01?.[0]?.statusdelasolicitud === 2) estatus = 'Pendiente Inspección';
                if (anexo?.solicitudesuifc01?.[0]?.statusdelasolicitud === 3) estatus = 'Informe revisión';
                if (anexo?.solicitudesuifc01?.[0]?.statusdelasolicitud === 4) estatus = 'Solicitud atendida';
                const revisor = anexo?.solicitudesuifc01.length > 0
                    ? `${anexo?.solicitudesuifc01[0]?.inspector?.nombre} ${anexo?.solicitudesuifc01[0]?.inspector?.apellidos}`
                    : '';
                return {
                    id: anexo?.idfc01_solicitudregistro,
                    nombre: anexo?.nombrerazonsocial,
                    folio: anexo?.folio,
                    socio: anexo?.numerosocio,
                    estatus,
                    revisor, anexo
                };
            });
            setRows(formattedRows);
        });
    }, [page, pageSize, openModalAsignarInspector]);

    const [informacionFormik, setInformacionFormik] = React.useState(
        {
            fechaHoy: "",
            NoAsignacion: "",
            numerosocio: '',
            razonSocial: "",
            nombre: "",
            telefono: "",
            correoElectronico: "",
            tipoInstalacion: "",
            domicilio: "",
            fechaSolicitud: "",
            fechaAsignacion: "",
            tiposervicio: "",
            descripcionproducto: "",
            inspectorAcreditado: "",
            inspectorCapacitacion: "",
            credencialCapacitacion: "",
        }
    );
    console.log('los datos son ', informacionFormik)
    const [fechaSeleccionada, setFechaSeleccionada] = React.useState('');

    const handleOpenModalAsignarInspector = (opcion) => {
        console.log('los asignar ', opcion)
        setInformacionFormik(
            {
                idsolicitudesuifc01: opcion?.anexo?.solicitudesuifc01?.[0]?.idsolicitudesuifc01 || null,
                fechaHoy: "",
                NoAsignacion: "",
                razonSocial: opcion?.anexo?.nombrerazonsocial,
                numerosocio: opcion?.anexo?.numerosocio,
                idfc01_solicitudregistro: opcion?.id,
                nombre: "",
                telefono: "",
                correoElectronico: "",
                tipoInstalacion: "",
                domicilio: "",
                nosolicitud: opcion?.anexo?.informacionmodalaceptada?.numerosolicitudservicios ||'',
                fechaSolicitud: moment(opcion?.anexo?.fechasolicitud).add(1, 'd').format('YYYY-MM-DD'),
                fechaAsignacion: "",
                tiposervicio: "DICTAMEN DE CUMPLIMIENTO CON LA NOM INSTALACIONES",
                descripcionproducto: "",
                inspectorAcreditado: "",
                inspectorCapacitacion: "",
                credencialCapacitacion: "",
            }
        )

        setOpenModalAsignarInspector(true)
    };

    const handleCloseModalAsignarInspector = () => setOpenModalAsignarInspector(false);

    const modalAsignarInspector = () => {
        return (
            <Modal
                open={openModalAsignarInspector}
                onClose={handleCloseModalAsignarInspector}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h5" component="h2" className='text-center' style={{ fontWeight: 'bold' }}>
                        ASIGNAR INSPECTOR
                    </Typography>
                    <br />

                    <Formik
                        initialValues={informacionFormik}
                        enableReinitialize
                        /*
                                1.- si no ha pasado el inspector: pendiente inspeccion.
                                2.- si ya paso el inspector: informe emitido.
                                3.- si esta en proceso de revision del informe: informe en revisión.
                                4.- Si ya lo reviso el gerente: dictamen emitido.
                                    cuando se finalize todo el proceso: Solictud atendida
                        */
                        onSubmit={async (values) => {
                            await generarAsignacionServicios(values)
                        }}
                    /*onSubmit={async (values) => {



                        let nombre = "";
                        inspectores.forEach((e) => {
                            if (e.login != null) {
                                if (e.login.idlogin === idUsuario.id) {
                                    nombre = e.nombre + " " + e.apellidos
                                }
                            }
                        })

                        let nombreIns = "";

                        inspectores.forEach((e) => {
                            if (e.idinspector === Number(values.inspectorseleccionado)) {
                                nombreIns = e.nombre + " " + e.apellidos
                            }
                        })

                        if (isReasignar === true) {

                            let fecha = new Date(fechaSeleccionada);
                            fecha.setDate(fecha.getDate() - 1);

                            const data = {
                                data: {
                                    idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                                    idinspector: Number(values.inspectorseleccionado),
                                    idfc01_solicitudregistro: Number(solicitud.idfc01_solicitudregistro),
                                    fecharealdeinspeccion: fecha,
                                    asignadopor: nombre,
                                    statusdelasolicitud: 1,
                                    folioui: values.folio,
                                    ncomision: values.escrito,
                                    isoffline: false
                                }
                            }
                            dispatch(updateSolicitud(data))
                            dispatch(getClienteByNumsocio(solicitud.numerosocio)).then(async (a) => {
                                dispatch(getInspectorById(values.inspectorseleccionado)).then(async (response) => {
                                    dispatch(obtenerInspectorByIdLogin(currentUser.user[0].id)).then(async (gerente) => {
                                        let nombreInspector;
                                        let apellidosInspector;
                                        nombreInspector = response.payload.data.data.nombre.split(" ")
                                        apellidosInspector = response.payload.data.data.apellidos.split(" ")

                                        let nombreArchivo = "FI01-";

                                        const fecha = Date.now();
                                        const hoy = new Date(fecha);

                                        let anio = hoy.getFullYear();
                                        let mes = hoy.getMonth() + 1;
                                        let dia = hoy.getDate();

                                        dia = ('0' + dia).slice(-2);
                                        mes = ('0' + mes).slice(-2);

                                        let anios = String(anio)
                                        let fechaForm = dia + "" + mes + "" + anios[2] + anios[3];
                                        let fechaForm2 = dia + "/" + mes + "/" + anios[2] + anios[3];
                                        let inicialesInspector = "";

                                        for (let i = 0; i < nombreInspector.length; i++) {
                                            inicialesInspector += nombreInspector[i][0]
                                        }

                                        for (let i = 0; i < apellidosInspector.length; i++) {
                                            inicialesInspector += apellidosInspector[i][0]
                                        }

                                        nombreArchivo += solicitud.numerosocio + "-" + values.escrito + "." + anios[2] + anios[3] + fechaForm + inicialesInspector + ".pdf"

                                        let nombregerente = gerente.payload.data.data.titulo + ". " + gerente.payload.data.data.nombre + " " + gerente.payload.data.data.apellidos


                                        const data = {
                                            numeroDeEscritoComision: values.escrito,
                                            fecha: fechaForm2,
                                            nombreDelCliente: solicitud.nombrerazonsocial,
                                            domicilioDelInstalacion: solicitud.calle + " " + solicitud.numeroexterior + " " + solicitud.municipioalcaldia + " " + solicitud.estado,
                                            telefono: solicitud.telefono,
                                            nombreInspector: nombreIns,
                                            idsolicitudesuifc01: solicitud.solicitudesuifc01[0].idsolicitudesuifc01,
                                            idcliente: a.payload.data.data.idcliente,
                                            nombreArchivo: nombreArchivo,
                                            reasignar: true,
                                            idinspector: gerente.payload.data.data.idinspector,
                                            nombregerente: nombregerente
                                        };
                                        const documento = await fetch(host + 'ArchivosUnidadInspeccion/actualizarEscritoDeComision', {
                                            method: 'POST',
                                            mode: 'cors',
                                            body: JSON.stringify(data),
                                            headers: new Headers({
                                                'Content-Type': 'application/json',
                                                'Access-Control-Allow-Origin': '*',
                                            }),
                                        })

                                        if (documento.status != 404) {
                                            const blob = await documento.blob();
                                            const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                                            //window.open(url);
                                            setUrlPDF(url)
                                            let a = document.createElement("a");
                                            a.href = url;
                                            a.download = nombreArchivo;
                                            a.click()
                                            if (props.isCalendario === false) {
                                                props.actualizarSolicitudes();
                                            } else if (props.isCalendario === true) {
                                                props.actualizarSolicitudes();
                                                props.handleCloseModalSolicitudes()
                                            }

                                            if (props.isZonas === true) {
                                                props.actualizarSolicitudes()
                                                props.handleCerrarModalSolicitudes()
                                            }

                                            await dispatch(actualizarLoadingApp_false())
                                        } else {

                                        }
                                    })
                                })
                            })

                        } else {
                            const data = {
                                data: {
                                    idinspector: Number(values.inspectorseleccionado),
                                    idfc01_solicitudregistro: Number(solicitud.idfc01_solicitudregistro),
                                    fecharealdeinspeccion: fechaSeleccionada,
                                    asignadopor: nombre,
                                    statusdelasolicitud: 1,
                                    folioui: values.folio,
                                    ncomision: values.escrito,
                                    isoffline: false
                                }
                            }
                            dispatch(insertSolicitud(data)).then(async (r) => {
                                dispatch(getClienteByNumsocio(solicitud.numerosocio)).then(async (a) => {
                                    dispatch(getInspectorById(values.inspectorseleccionado)).then(async (response) => {
                                        dispatch(obtenerInspectorByIdLogin(currentUser.user[0].id)).then(async (gerente) => {
                                            let nombreInspector;
                                            let apellidosInspector;
                                            nombreInspector = response.payload.data.data.nombre.split(" ")
                                            apellidosInspector = response.payload.data.data.apellidos.split(" ")

                                            let nombreArchivo = "FI01-";

                                            const fecha = Date.now();
                                            const hoy = new Date(fecha);

                                            let anio = hoy.getFullYear();
                                            let mes = hoy.getMonth() + 1;
                                            let dia = hoy.getDate();

                                            dia = ('0' + dia).slice(-2);
                                            mes = ('0' + mes).slice(-2);

                                            let anios = String(anio)
                                            let fechaForm = dia + "" + mes + "" + anios[2] + anios[3];
                                            let fechaForm2 = dia + "/" + mes + "/" + anios[2] + anios[3];
                                            let inicialesInspector = "";

                                            for (let i = 0; i < nombreInspector.length; i++) {
                                                inicialesInspector += nombreInspector[i][0]
                                            }

                                            for (let i = 0; i < apellidosInspector.length; i++) {
                                                inicialesInspector += apellidosInspector[i][0]
                                            }

                                            nombreArchivo += solicitud.numerosocio + "-" + values.escrito + "." + anios[2] + anios[3] + fechaForm + inicialesInspector + ".pdf"

                                            let nombregerente = gerente.payload.data.data.titulo + ". " + gerente.payload.data.data.nombre + " " + gerente.payload.data.data.apellidos

                                            const data = {
                                                numeroDeEscritoComision: values.escrito,
                                                fecha: fechaForm2,
                                                nombreDelCliente: solicitud.nombrerazonsocial,
                                                domicilioDelInstalacion: solicitud.calle + " " + solicitud.numeroexterior + " " + solicitud.municipioalcaldia + " " + solicitud.estado,
                                                telefono: solicitud.telefono,
                                                nombreInspector: nombreIns,
                                                idsolicitudesuifc01: r.payload.data.data.idsolicitudesuifc01,
                                                idcliente: a.payload.data.data.idcliente,
                                                nombreArchivo: nombreArchivo,
                                                reasignar: false,
                                                idinspector: gerente.payload.data.data.idinspector,
                                                nombregerente: nombregerente
                                            };
                                            const documento = await fetch(host + 'ArchivosUnidadInspeccion/generarEscritoDeComision', {
                                                method: 'POST',
                                                mode: 'cors',
                                                body: JSON.stringify(data),
                                                headers: new Headers({
                                                    'Content-Type': 'application/json',
                                                    'Access-Control-Allow-Origin': '*',
                                                }),
                                            })

                                            if (documento.status != 404) {
                                                const blob = await documento.blob();
                                                const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
                                                //window.open(url);
                                                setUrlPDF(url)
                                                let a = document.createElement("a");
                                                a.href = url;
                                                a.download = nombreArchivo;
                                                a.click()
                                                if (props.isCalendario === false) {
                                                    props.actualizarSolicitudes();
                                                } else if (props.isCalendario === true) {
                                                    props.actualizarSolicitudes();
                                                    props.handleCloseModalSolicitudes()
                                                }

                                                if (props.isZonas === true) {
                                                    props.actualizarSolicitudes()
                                                    props.handleCerrarModalSolicitudes()
                                                }

                                                await dispatch(actualizarLoadingApp_false())
                                            } else {

                                            }
                                        })
                                    })
                                })
                            })
                        }
                        if (props.isCalendario === false) {
                            props.actualizarSolicitudes();
                        } else if (props.isCalendario === true) {
                            props.actualizarSolicitudes();
                            props.handleCloseModalSolicitudes()
                        }

                        if (props.isZonas === true) {
                            props.actualizarSolicitudes()
                            props.handleCerrarModalSolicitudes()
                        }

                        handleCloseModalAsignarInspector()
                    }}*/
                    >
                        {({ setFieldValue }) => (
                            <Form>
                                <div className='row col-12'>
                                    <div className='col-xs-4 col-sm-4 col-md-4 col-xl-4 col-xxl-4'>
                                        <div className="form-floating mb-3">
                                            <Field type="date" id="fechaEmision" name="fechaEmision"
                                                placeholder="Fecha Emisión" className="form-control" onWheel={event => event.currentTarget.blur()}
                                            />
                                            <label htmlFor="fechaEmision">Fecha Emisión</label>
                                            <ErrorMessage name="fechaEmision" component="div" className="text-danger" />
                                        </div>
                                    </div>
                                    <div className='col-xs-4 col-sm-4 col-md-4 col-xl-4 col-xxl-4'>
                                        <div className="form-floating mb-3">
                                            <Field type="date" id="fechaSolicitud" name="fechaSolicitud"
                                                placeholder="Fecha Soliciutd" className="form-control" onWheel={event => event.currentTarget.blur()}
                                            />
                                            <label htmlFor="fechaSolicitud">Fecha Soliciutd</label>
                                            <ErrorMessage name="fechaSolicitud" component="div" className="text-danger" />
                                        </div>
                                    </div>
                                    <div className='col-xs-4 col-sm-4 col-md-4 col-xl-4 col-xxl-4'>
                                        <div className="form-floating mb-3">
                                            <Field type="date" id="fechaAsignacion" name="fechaAsignacion"
                                                placeholder="Fecha Asignación" className="form-control" onWheel={event => event.currentTarget.blur()}
                                            />
                                            <label htmlFor="fechaAsignacion">Fecha Asignación</label>
                                            <ErrorMessage name="fechaAsignacion" component="div" className="text-danger" />
                                        </div>
                                    </div>
                                    <div className='col-xs-6 col-sm-6 col-md-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            <Field type="text" id="NoAsignacion" name="NoAsignacion" required
                                                placeholder="Número de Asignación" className="form-control" onWheel={event => event.currentTarget.blur()}
                                            />
                                            <label htmlFor="NoAsignacion">Número de asignación</label>
                                            <ErrorMessage name="NoAsignacion" component="div" className="text-danger" />
                                        </div>
                                    </div>
                                    <div className='col-xs-6 col-sm-6 col-md-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            <Field type="text" id="tiposervicio" name="tiposervicio" required
                                                placeholder="Número de solicitud" className="form-control" onWheel={event => event.currentTarget.blur()}
                                            />
                                            <label htmlFor="tiposervicio">Tipo de servicio</label>
                                            <ErrorMessage name="tiposervicio" component="div" className="text-danger" />
                                        </div>
                                    </div>
                                    <div className='col-xs-6 col-sm-6 col-md-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            <Field type="text" id="nosolicitud" name="nosolicitud" required
                                                placeholder="Número de solicitud" className="form-control" onWheel={event => event.currentTarget.blur()}
                                            />
                                            <label htmlFor="nosolicitud">Número de solicitud</label>
                                            <ErrorMessage name="nosolicitud" component="div" className="text-danger" />
                                        </div>
                                    </div>
                                    <div className='col-xs-6 col-sm-6 col-md-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            <Field type="text" id="informacinadicional" name="informacinadicional" required
                                                placeholder="Información adicional del servicio" className="form-control" onWheel={event => event.currentTarget.blur()}
                                            />
                                            <label htmlFor="informacinadicional">Información adicional del servicio</label>
                                            <ErrorMessage name="informacinadicional" component="div" className="text-danger" />
                                        </div>
                                    </div>
                                    <div className='col-xs-6 col-sm-6 col-md-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            <Field type="text" id="descripcionproducto" name="descripcionproducto" required
                                                placeholder="Descripción del producto" className="form-control" onWheel={event => event.currentTarget.blur()}
                                            />
                                            <label htmlFor="descripcionproducto">Descripción del producto</label>
                                            <ErrorMessage name="descripcionproducto" component="div" className="text-danger" />
                                        </div>
                                    </div>
                                    <div className='col-xs-6 col-sm-6 col-md-6 col-xl-6 col-xxl-6'>
                                        <div className="form-floating mb-3">
                                            <Field
                                                as="select"
                                                name="inspector"
                                                id="inspector"
                                                required
                                                className="form-select"
                                                onChange={(e) => {
                                                    const idinspector = e.target.value;
                                                    const inspector = inspectores?.find(ins => ins.idinspector == Number(idinspector));
                                                    setFieldValue("inspector", idinspector); // <-- mantener el id seleccionado
                                                    setFieldValue("acreditacion", inspector?.acreditacion || ""); // otro campo opcional
                                                    setFieldValue("nombreInspector", inspector ? `${inspector.nombre} ${inspector.apellidos}` : ""); // si necesitas el nombre aparte
                                                }}
                                            >
                                                <option value="">Selecciona un inspector</option>
                                                {inspectores?.map(anexo => (
                                                    <option key={anexo.idinspector} value={anexo.idinspector}>
                                                        {anexo.nombre + ' ' + anexo.apellidos}
                                                    </option>
                                                ))}
                                            </Field>
                                            <label htmlFor="inspector">Inspector</label>
                                            <ErrorMessage name="inspector" component="div" className="text-danger" />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ textAlign: 'center' }}>
                                    <button type='submit' className='btn btn-success'>Guardar</button>
                                    <button className='ms-3 btn btn-dark' onClick={() => handleCloseModalAsignarInspector()}>Canelar</button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Box>
            </Modal>
        )
    }
    const generarAsignacionServicios = async (data) => {
        console.log('los datos son ', data)
        let res = null
        if (data?.idsolicitudesuifc01 == null) {
            let dataSolicitud = {
                data: {
                    idinspector: Number(data.inspector),
                    idfc01_solicitudregistro: Number(data?.idfc01_solicitudregistro),
                    fecharealdeinspeccion: new Date(data?.fechaAsignacion).toISOString(),
                    asignadopor: currentUser?.user?.[0]?.user, statusdelasolicitud: 1,
                    folioui: data?.NoAsignacion, ncomision: data?.numerosocio,
                    isoffline: false, observaciones: data?.informacinadicional,
                    fechaemision: new Date(data?.fechaEmision).toISOString(),
                    fechasolicitud: new Date(data?.fechaSolicitud).toISOString(),
                    tiposervicio: data?.tiposervicio, descripcionproducto: data?.descripcionproducto
                }
            }
            res = await dispatch(insertSolicitud(dataSolicitud))
        } else {
            let dataSolicitud = {
                data: {
                    idsolicitudesuifc01: data?.idsolicitudesuifc01,
                    idinspector: Number(data.inspector),
                    idfc01_solicitudregistro: Number(data?.idfc01_solicitudregistro),
                    fecharealdeinspeccion: new Date(data?.fechaAsignacion).toISOString(),
                    asignadopor: currentUser?.user?.[0]?.user, statusdelasolicitud: 1,
                    folioui: data?.NoAsignacion, ncomision: data?.numerosocio,
                    isoffline: false, observaciones: data?.informacinadicional,
                    fechaemision: new Date(data?.fechaEmision).toISOString(),
                    fechasolicitud: new Date(data?.fechaSolicitud).toISOString(),
                    tiposervicio: data?.tiposervicio, descripcionproducto: data?.descripcionproducto
                }
            }
            res = await dispatch(updateSolicitud(dataSolicitud))
        }
        console.log('res es ', res)
        data.idsolicitudesuifc01 = res?.payload?.data?.data?.idsolicitudesuifc01
        let instalaciones = await dispatch(obtenerInstalacionesFC_01(data?.idfc01_solicitudregistro))
        console.log('los datos son ', instalaciones?.payload?.data?.data)
        data.instalaciones = instalaciones?.payload?.data?.data
        await dispatch(generarSolicitudAsignacionServicios(data))
        await handleCloseModalAsignarInspector()
    }
    const verDocumentoAsignacion = async (data) => {
        await dispatch(actualizarLoadingApp_true())
        const fileFetch = await fetch(host + `FC_01/servirAchivosGenerales/tabla=${'fi_25_documenentos'}&nombreId=${'idsolicitudesuifc01'}&idSolicitud=${data?.anexo?.solicitudesuifc01?.[0]?.idsolicitudesuifc01}&idoficio=${25}`)

        await dispatch(actualizarLoadingApp_false())
        if (fileFetch.status != 404) {
            const blob = await fileFetch.blob();
            const url = window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
            window.open(url);
        } else {
            Swal.fire("Archivo no encontrado", "", "error");
        }
    }
    return (
        <Fragment >
            <div className="col-12 ms-3 text-center">
                <div style={{ height: 660, width: "100%", color: "black" }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        pagination
                        paginationMode="server"
                        rowCount={total}
                        onPageChange={(newPage) => setPage(newPage)}
                        page={page}
                        rowsPerPageOptions={[10, 20, 50]}
                        components={{
                            Toolbar: QuickSearchToolbar,
                        }}
                        sx={{
                            boxShadow: 0,
                            color: "black",
                            border: 0,
                            "& .MuiDataGrid-cell": {
                                display: "block",
                                position: "relative",
                                textAlign: "center",
                            },
                        }}
                    />

                </div>
            </div>
            {modalAsignarInspector()}
        </Fragment>

    );
}

export default withRouter(SolicitudFC01UIComponent)